import React from 'react';
import '../index.css';
import { t } from '../i18n';

const CarouselDots = ({ count, currentIndex, onSelect }) => {
  // If 5 or fewer items, show simple dots
  if (count <= 5) {
    return (
      <div className="carousel-dots-simple">
        {Array.from({ length: count }).map((_, i) => (
          <button
            key={i}
            className={`carousel-dot ${i === currentIndex ? 'active' : ''}`}
            onClick={() => onSelect(i)}
            aria-label={`${t('goToItem')} ${i + 1}`}
          />
        ))}
      </div>
    );
  }

  // Determine the start of the sliding window
  // We want to keep currentIndex centered if possible (relative index 2)
  // Clamp windowStart between 0 and count - 5
  // Examples:
  // count=10, current=0 -> start=0 (window 0..4)
  // count=10, current=2 -> start=0 (window 0..4)
  // count=10, current=3 -> start=1 (window 1..5)
  // count=10, current=7 -> start=5 (window 5..9)
  // count=10, current=8 -> start=5 (window 5..9)
  const windowStart = Math.min(Math.max(0, currentIndex - 2), count - 5);
  
  const dots = [];
  for (let i = 0; i < 5; i++) {
    const absIndex = windowStart + i; 
    let sizeClass = 'big';

    // Logic for dot sizes based on window position
    if (windowStart === 0) {
      // Start of list: [B, B, B, B, S]
      // Index 4 (last visible) is small
      if (i === 4) sizeClass = 'small';
    } else if (windowStart === count - 5) {
      // End of list: [S, B, B, B, B]
      // Index 0 (first visible) is small
      if (i === 0) sizeClass = 'small';
    } else {
      // Middle of list: [S, B, B, B, S]
      // First and last visible are small
      if (i === 0 || i === 4) sizeClass = 'small';
    }

    dots.push({
      index: absIndex,
      sizeClass,
    });
  }

  return (
    <div className="carousel-dots-sliding-wrapper">
      <div className="carousel-dots-sliding">
        {dots.map(({ index, sizeClass }) => (
          <button
            key={index}
            className={`carousel-dot ${sizeClass} ${index === currentIndex ? 'active' : ''}`}
            onClick={() => onSelect(index)}
            aria-label={`${t('goToItem')} ${index + 1}`}
            style={{
              // Optional: Add a transition delay if needed, or rely on CSS
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default CarouselDots;